import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { DataModel, SerializationContext, SerializedData, DataModelBuilder } from '../dto/data-model.js';
import { cloneList, isSameData, isSameList } from '../dto/data-model-utils.js';
import { BusinessModuleRef } from './business-module-ref.js';

export class TicketBatch extends DataModel {
  static readonly TYPE_ID: string = 'bad87a1ca796456cb73fcfea64e277b9';

  public readonly ticketCount: number;

  constructor(
    public readonly uniqueId: string,
    public readonly creatorId: string,
    public readonly creationDate: dayjs.Dayjs,
    public readonly businessRef: BusinessModuleRef,
    public readonly eventId: string,
    public readonly jobId: string,
    public readonly tickets: string[],
  ) {
    super();

    this.ticketCount = tickets.length;
  }

  get $typeId(): string {
    return TicketBatch.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketBatch {
    return new TicketBatch(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'creatorId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
        MapUtils.get<string>(map, 'eventId'),
        MapUtils.get<string>(map, 'jobId'),
        MapUtils.getList<string>(map, 'tickets', (item) => item as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'creatorId': this.creatorId,
      'creationDate': context.encodeDate(this.creationDate),
      'businessRef': this.businessRef.encode(),
      'eventId': this.eventId,
      'jobId': this.jobId,
      'tickets': this.tickets,
    };
  }

  clone(): this {
    return new TicketBatch(
        this.uniqueId,
        this.creatorId,
        TimeZone.cloneDate(this.creationDate),
        this.businessRef.clone(),
        this.eventId,
        this.jobId,
        cloneList(this.tickets),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.creatorId === this.creatorId &&
        other.creationDate === this.creationDate &&
        isSameData(other.businessRef, this.businessRef) &&
        other.eventId === this.eventId &&
        other.jobId === this.jobId &&
        isSameList(other.tickets, this.tickets);
  }
}

export class TicketBatchBuilder extends DataModelBuilder<TicketBatch> {
  build(context: SerializationContext, map: SerializedData): TicketBatch {
    return TicketBatch.fromMap(context, map);
  }
}
